import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getImage } from "../Utils/image_helper";

export const FreePlanLimitReachedModal = ({ isOpen, onClose, limit, type, planName }) => {
    const navigate = useNavigate();

    return (
        <Modal show={isOpen} onHide={onClose} centered dialogClassName="wide-modal">
            <div className="text-center px-3 py-3">
                <Modal.Header closeButton className="border-0 justify-content-center pb-1" />

                <Modal.Body className="text-muted p-5 pt-3">
                    <h5 className="fw-bold mb-5 text-secondary-light">
                        You've reached your <br /> {planName} {type} limit
                    </h5>

                    <div className="d-flex justify-content-center mt-2 mb-3">
                        <img
                            src={getImage("freePlanLimitREached")}
                            alt="Invoice Illustration"
                            style={{
                                width: "170px",
                                maxWidth: "100%",
                            }}
                        />
                    </div>

                    <p className="mb-1 text-secondary-light">
                        You can create up to <strong>{limit} {type}{limit > 1 && 's'}</strong> on the {planName}.
                    </p>
                    <p className="mb-5 text-secondary-light">
                        Create unlimited {type}{limit > 1 && 's'} by upgrading your plan.
                    </p>

                    <div className="d-flex flex-column gap-3">
                        <Button
                            variant="primary"
                            className="w-100 fw-semibold py-2 shadow-sm"
                            onClick={() => navigate("/pricing")}
                            style={{
                                fontSize: "16px",
                                borderRadius: "8px",
                                height: 44,
                            }}
                        >
                            🚀 Upgrade your plan
                        </Button>

                        <Button
                            variant="light"
                            className="w-100 py-2 fw-medium border"
                            onClick={onClose}
                            style={{
                                fontSize: "15px",
                                borderRadius: "8px",
                                color: "#6b7280",
                                borderColor: "#d1d5db",
                                backgroundColor: "#f9fafb",
                                height: 44,
                            }}
                        >
                            Maybe later
                        </Button>
                    </div>

                </Modal.Body>
            </div>
        </Modal>
    );
};
